var app = angular.module("leonardo");

var UserMenu = function ($scope, $element, $document, $state, $http, $rootScope, $timeout, AuthDataService,
  FilterService, NavigationService, RestangularProvider, AccountUserService, AuthService,
  ConfigThemeService, CacheService, StatsigService, AnalyticsService, IoShareRedirectService) {

  $scope.authDataService = AuthDataService;
  $scope.authService = AuthService;
  $scope.configThemeService = ConfigThemeService;

  $scope.showMenu = false;
  $scope.showNewVersion = false;
  $scope.newVersionUrl = window.LEO_NEW_EXPERIENCE_URL || '';

  StatsigService.checkGate('beta_forced_opt_in').then(function (forced) {
    if (forced && !!$scope.newVersionUrl) {
      // Preserve a pending share deep link so the iO redirect lands on the
      // equivalent share page instead of the iO root.
      var target = IoShareRedirectService.consumeStoredShareUrl() || $scope.newVersionUrl;
      IoShareRedirectService.redirect(target);
    }
  });

  StatsigService.checkGate('beta_opt_in_opt_out').then(function (enabled) {
    var beforeLegacyRetires = new Date() < new Date(2027, 0, 1);
    $scope.showNewVersion = enabled && !!$scope.newVersionUrl && beforeLegacyRetires;
    $timeout(function () {
      if ($rootScope.initLayout) {
        $rootScope.initLayout();
      }
    }, 0);
    var urlParams = new URLSearchParams(window.location.search);
    if (enabled && !!$scope.newVersionUrl) {
      if (urlParams.get('from_new_experience') === 'true') {
        urlParams.delete('from_new_experience');
        var cleanSearch = urlParams.toString();
        var cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
        localStorage.removeItem('from_legacy');
        window.location.replace(cleanUrl);
      } else if (localStorage.getItem('from_legacy') === 'true') {
        $scope.redirectToNewVersion();
      }
    }
  });

  $scope.redirectToNewVersion = function () {
    var token = localStorage.getItem('jwt_token');
    var base = $scope.newVersionUrl;
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    var params = 'from_legacy=true' + (token ? '&token=' + encodeURIComponent(token) : '');
    window.location.href = base + separator + params;
  };

  $scope.switchToNewVersion = function () {
    AnalyticsService.track('Switched to New Version');
    localStorage.setItem('from_legacy', 'true');
    $scope.redirectToNewVersion();
  };

  $scope.seeWhatMoved = function () {
    var base = 'https://leonardo247.zendesk.com/hc/en-us/articles/49012731123475-Finding-Your-Favorite-Features-in-the-New-App-Experience';
    window.location.href = base;
  }

  $scope.showUserMenu = function () {
    angular.element('.wrapper-user-logged .menu-popup').slideToggle(450);
    $scope.showMenu = !$scope.showMenu;
    $timeout(function () {
      $scope.showMenu = angular.element('.wrapper-user-logged .menu-popup').is(':visible');
    }, 460);
  };

  $scope.restoreUser = function () {
    localStorage.setItem('jwt_token', localStorage.getItem('jwt_token_old'));
    localStorage.removeItem('jwt_token_old');
    localStorage.removeItem('jwt_user_id_old');
    localStorage.removeItem('jwt_old_user');
    FilterService.resetFilters();
    CacheService.clearAll();
    NavigationService.goToLoginRedirectionWorkAs();
  };

  $scope.showAccountManagements = function () {
    return AuthDataService.isNotStaff() && AuthDataService.authData.account && AccountUserService.currentAccountUser &&
      (AccountUserService.currentAccountUser.is_owner) &&
      (AuthDataService.authData.account.id == AccountUserService.currentAccountUser.account);
  };

  $scope.onDocumentClick = function (event) {
    if (($element.find(event.target).length === 0) && $scope.showMenu) {
      angular.element('.wrapper-user-logged .menu-popup').slideUp();
      $scope.showMenu = false;
    }
  };

  $document.on("click", $scope.onDocumentClick);
};

app.controller('UserMenu', ['$scope', '$element', '$document', '$state', '$http', '$rootScope', '$timeout',
  'AuthDataService', 'FilterService', 'NavigationService', 'Restangular', 'AccountUserService', 'AuthService',
  'ConfigThemeService', 'CacheService', 'StatsigService', 'AnalyticsService', 'IoShareRedirectService', UserMenu]);
